import React from 'react';
import { FormControlLabel, Switch } from '@material-ui/core';
import './StyledSwitch.scss';

const StyledSwitch = ({checked, onChange, label, ...rest}) => (
    <FormControlLabel
        control={
            <Switch
                checked={checked}
                onChange={(event) => onChange(event.target.checked)}
                color="primary"
            />
        }
        label={label}
        className="rse-form-control"
        {...rest}
    />
);

export default StyledSwitch;
